(function ($) {
  Drupal.behaviors.dw_color_correctors_transformation_carousel_transformation_formatter = {
    attach: function (context) {
      $('.js-dwcc-carousel__v2', context).once(function () {
        /*
        /--------------------------------------------------------------------------
        / Estée.
        /--------------------------------------------------------------------------
        // Set the context for the carousel.
        / Remove the additional wrapper contents on the carousel content-blocks to
        / prevent styling issues.
        */
        var context = $('.js-dwcc-carousel__v2');
        var extraElements = context.find('.node.node-elc-nodeblock, .content, div:not([class])');

        extraElements.contents().unwrap();

        /*
         * --------------------------------------------------------------------------
         * CONTINUOUS CAROUSEL V1.5
         * --------------------------------------------------------------------------
         * Functionality for a Continuous Carousel with the following features:
         * Allows for the addition of infinite slides.
         * Updates the contents of dummy slides accordingly.
         * Adds identifying classes to each slide for ease of reference.
         * Adds an active class to each slide for ease of visibility.
         * jQuery events can be managed separately by listening to a counter.
         * Updates to allow for content-managed pag-dots.
         */
        /*
        /--------------------------------------------------------------------------
        / Strip any whitespace to prevent spaces between slides (commnet out if
        / not required).
        /--------------------------------------------------------------------------
        */
        var stripWhiteSpace = context.find('*');

        stripWhiteSpace.contents().filter(function () {
          return this.nodeType = Node.TEXT_NODE && /\S/.test(this.nodeValue) === false;
        }).remove();

        /*
        /--------------------------------------------------------------------------
        / Calculate the number of slides.
        /--------------------------------------------------------------------------
        */
        var carouselWrapper = context.find('.js-dwcc-carousel__carouselWrapper');
        var slideTotal = (carouselWrapper.children().length + carouselWrapper.find('.js-dwcc-carousel__carouselInner').children().length) - 1;
        var slideTotalPerc = (slideTotal * 100) + '%';

        context.find('.js-dwcc-carousel__carouselWrapper').css('width', slideTotalPerc);

        /*
        /--------------------------------------------------------------------------
        / Handle pagination dots.
        /--------------------------------------------------------------------------
        / Grab the pagination divs from each slide & append
        / them to the pagination container.
        / Add identifying classes to them.
        / Make first slide pagination have the selected class.
        */
        var paginationElems = context.find('.js-dwcc-carousel__carouselInner').find('div.dwcc-transformation-carousel__slide--v2 .js-dwcc-slide__pag');

        paginationElems.each(function (i) {
          $(this).detach().appendTo('.dw_color_correctors_transformation_carousel_pagination');
          $(this).addClass('dwcc-slide__pag_' + (i + 1));
        });
        $('.dwcc-slide__pag_1').addClass('dwcc-slide__pag--selected').next().addClass('next_pag');

        /*
        /--------------------------------------------------------------------------
        / Add identifying classes to the slides.
        /--------------------------------------------------------------------------
        */
        context.find('.js-dwcc-carousel__carouselInner .dwcc-transformation-carousel__slide--v2').each(function (i) {
          $(this).addClass('dw_color_correctors_transformation_carousel_slide_' + (i + 1));
        });

        /*
        /--------------------------------------------------------------------------
        / Handle the placeholder slides.
        /--------------------------------------------------------------------------
        / Setup variables.
        / Clone the contents from first & last slide to placeholder slides.
        / Comment out if not required.
        */
        var firstSlide = context.find('.js-dw_color_correctors_transformation_carousel_slideFirst').html();
        var secondSlide = context.find('.js-dw_color_correctors_transformation_carousel_slideFirst').next().html();
        var secondLastSlide = context.find('.js-dw_color_correctors_transformation_carousel_slideLast').prev().html();
        var lastSlide = context.find('.js-dw_color_correctors_transformation_carousel_slideLast').html();

        if (firstSlide.length || lastSlide.length) {
          context.find('.js-dw_color_correctors_transformation_carousel_holder_first').append(secondLastSlide);
          context.find('.js-dw_color_correctors_transformation_carousel_holder_second').append(lastSlide);
          context.find('.js-dw_color_correctors_transformation_carousel_holder_secondLast').append(firstSlide);
          context.find('.js-dw_color_correctors_transformation_carousel_holder_last').append(secondSlide);
        }
        context.find('.js-dw_color_correctors_transformation_carousel_slideFirst').addClass('active');

        /*
        /--------------------------------------------------------------------------
        / Handle resizing.
        /--------------------------------------------------------------------------
        / On resize and on page load.
        */
        var resizeTimer;
        var hasResized = false;

        if ($(window).width() < 1366) {
          $('.dwcc-transformation-carousel__slide--v2').css('width', 'calc(100%/' + slideTotal + ' - 35.824vw)');
        }
        $(window).on('resize', function () {
          // Throttle/ debounce resize event:
          clearTimeout(resizeTimer);
          resizeTimer = setTimeout(function () {
            if (hasResized === false) {
              if ($(window).width() < 1366) {
                hasResized = true;
                $('.dwcc-transformation-carousel__slide--v2').css('width', 'calc(100%/' + slideTotal + ' - 35.824vw)');
              } else {
                return;
              }
            } else {
              if ($(window).width() >= 1366) {
                hasResized = false;
                $('.dwcc-transformation-carousel__slide--v2').css('width', '');
              } else {
                return;
              }
            }
          }, 50);
        });

        /*
        /--------------------------------------------------------------------------
        / Calculate the slide animation value.
        /--------------------------------------------------------------------------
        / Setup values.
        */
        var innerSlideTotal = context.find('.js-dwcc-carousel__carouselInner').children().length;
        var pagCount = slideTotal - 2;
        var isAnimating, pagAnimating, goingLeft, goingRight;

        isAnimating = pagAnimating = goingLeft = goingRight = false;
        var theDirection, pagDirection;
        var counter = 0;
        var slideDivide = slideTotal / slideTotal;
        var resetRight = -innerSlideTotal;
        var resetLeft = slideDivide;
        var counterRight = slideDivide - 1;
        var counterLeft = -(innerSlideTotal - 1);
        var increment = 65.65;
        var baseMarginVal = 114.2;
        var marginResetRight = -baseMarginVal + '%';
        var chevronVal = context.find('.js-dwcc-carousel__carouselnav').length;
        var marginResetLeft = -(baseMarginVal + (increment * (innerSlideTotal - 1))) + '%';

        /*
        /--------------------------------------------------------------------------
        / Handle the Carousel animation and counter.
        /--------------------------------------------------------------------------
        / Add functions to add/remove active class.
        / Add function to switch the first/last active class.
        / Handle the pagination dots.
        / Handle the carousel animation and counters.
        / Check for rtl.
        */
        function activeNext() {
          context.find('.dwcc-transformation-carousel__slide--v2.active').next().addClass('active').siblings().removeClass('active');
        }

        function activePrev() {
          context.find('.dwcc-transformation-carousel__slide--v2.active').prev().addClass('active').siblings().removeClass('active');
        }

        function switchActive(slide1, slide2) {
          context.find('.dwcc-transformation-carousel__slide--v2' + slide1 + '.active').siblings('.dwcc-transformation-carousel__slide--v2' + slide2).addClass('active').siblings().removeClass('active');
        }

        // Pagination dot events.
        // Update the pagCount according to the number of slides.
        // Boutique-specific: fade in third slide
        function animatePagination(pagCount) {
          context.find('.dwcc-slide__pag_' + pagCount).click(function () {
            if (!$(this).hasClass('dwcc-slide__pag--selected')) {
              if (pagAnimating === false) {
                pagAnimating = true;
                var pagVal = $(this).index();
                var animVal = -(baseMarginVal + (increment * pagVal));

                pagDirection = animVal + '%';
                $(this).addClass('dwcc-slide__pag--selected').siblings().removeClass('dwcc-slide__pag--selected');
                carouselWrapper.animate({
                  marginLeft: pagDirection
                }, 600, 'easeInOutQuad', function () {
                  // Reset counter for chevrons.
                  counter = 1 - pagCount;
                  context.find('.dw_color_correctors_transformation_carousel_slide_' + pagCount).addClass('active').siblings().removeClass('active');
                  pagAnimating = false;
                });
              }
            }
          });
        }
        for (var i = 1; i <= pagCount; i++) {
          animatePagination(i);
        }

        // Check for RTL
        var isRTL = false;

        setTimeout(function () {
          if ($('.field-content').hasClass('pcl_rtl')) {
            isRTL = true;
          }
        }, 1000);

        // Determine direction (RTL support)
        function negDirection() {
          theDirection = '-=' + increment + '%';
          counter--;
          goingRight = true;
          goingLeft = false;
        }

        function posDirection() {
          theDirection = '+=' + increment + '%';
          counter++;
          goingRight = false;
          goingLeft = true;
        }

        // Carousel animation handling
        function animateCarousel(arrowNo) {
          context.find('.js-dwcc-carousel__carouselnav_' + arrowNo).click(function () {
            if (isAnimating === false) {
              isAnimating = true;
              if (arrowNo === 1) {
                if (isRTL) {
                  negDirection();
                } else {
                  posDirection();
                }
              } else {
                if (isRTL) {
                  posDirection();
                } else {
                  negDirection();
                }
              }
              carouselWrapper.animate({
                marginLeft: theDirection
              }, 600, 'easeInOutQuad', function () {
                if (goingRight) {
                  activeNext();
                } else if (goingLeft) {
                  activePrev();
                }
                if (counter === resetRight) {
                  carouselWrapper.css({
                    'margin-left': marginResetRight
                  });
                  counter = counterRight;
                  switchActive('Last', 'First');
                } else if (counter === resetLeft) {
                  carouselWrapper.css({
                    'margin-left': marginResetLeft
                  });
                  counter = counterLeft;
                  switchActive('First', 'Last');
                }
                var pagNum = 1 - counter;

                context.find('.dwcc-slide__pag_' + pagNum).addClass('dwcc-slide__pag--selected').siblings().removeClass('dwcc-slide__pag--selected');
                isAnimating = false;
              });
            }
          });
        }
        for (var j = 1; j <= chevronVal; j++) {
          animateCarousel(j);
        }
      });
    }
  };
})(jQuery);
